import { IconCrown, IconRocket, IconSparkles } from '@tabler/icons-react'

import type { BadgeVariant } from '@/components/sui/badge'
import type { IconComponent } from '@/lib/icons/types'

// Starter = Rocket + violet
// Business = Sparkles + emerald
// Enterprise = Crown + blue

export interface PlanVisualConfig {
  icon: IconComponent
  badgeVariant: BadgeVariant
  iconBg: string
  iconColor: string
  iconFilled: string
  button: string
}

export const PLAN_VISUAL_CONFIG: Record<string, PlanVisualConfig> = {
  One: {
    icon: IconRocket,
    badgeVariant: 'starter',
    iconBg: 'bg-violet-100 dark:bg-violet-900/20',
    iconColor: 'text-violet-600 dark:text-violet-400',
    iconFilled:
      'fill-violet-600 stroke-violet-600 dark:fill-violet-400 dark:stroke-violet-400',
    button:
      'bg-violet-600 hover:bg-violet-700 focus-visible:border-violet-600 focus-visible:ring-violet-600/50',
  },
  Pro: {
    icon: IconSparkles,
    badgeVariant: 'business',
    iconBg: 'bg-emerald-100 dark:bg-emerald-900/20',
    iconColor: 'text-emerald-600 dark:text-emerald-400',
    iconFilled:
      'fill-emerald-600 stroke-emerald-600 dark:fill-emerald-400 dark:stroke-emerald-400',
    button:
      'bg-emerald-600 hover:bg-emerald-700 focus-visible:border-emerald-600 focus-visible:ring-emerald-600/50',
  },
  Max: {
    icon: IconCrown,
    badgeVariant: 'enterprise',
    iconBg: 'bg-blue-100 dark:bg-blue-900/20',
    iconColor: 'text-blue-600 dark:text-blue-400',
    iconFilled:
      'fill-blue-600 stroke-blue-600 dark:fill-blue-400 dark:stroke-blue-400',
    button:
      'bg-blue-600 hover:bg-blue-700 focus-visible:border-blue-600 focus-visible:ring-blue-600/50',
  },
}

const NON_PAID_PLAN_BADGES: Record<string, BadgeVariant> = {
  Trial: 'trial',
  Free: 'free',
}

export function getPlanBadgeVariant(
  featureType: string | null | undefined,
): BadgeVariant {
  if (featureType && featureType in PLAN_VISUAL_CONFIG)
    return PLAN_VISUAL_CONFIG[featureType].badgeVariant
  if (featureType && featureType in NON_PAID_PLAN_BADGES)
    return NON_PAID_PLAN_BADGES[featureType]
  return 'neutral'
}
